export const MAX_RECOMMENDED_PRODUCTS = 14;
export const SCORE_LOWER_BOUND = 74;
export const SCORE_UPPER_BOUND = 99;
export const MAX_SERIES_PRODUCTS = 3;
